module.exports = __webpack_public_path__ + "img/logo-light.4c556d30.svg";